import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_TICKET_DESIGNER_FEATURE_GROUP } from './group';

export const DEVELOPMENT_TICKET_DESIGNER_FEATURES = {
  ACCESS: {
    guid: '1c3edbc2-e6b1-4776-a99d-7930b2d00001',
    name: 'development:ticket-designer:access',
    description: 'Access the Ticket Designer development tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_TICKET_DESIGNER_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_TICKET_DESIGNER_FEATURE_GROUP } from './group';

export const DEVELOPMENT_TICKET_DESIGNER_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_TICKET_DESIGNER_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_TICKET_DESIGNER_FEATURES),
};
